import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const SystemCompatibilityPage = () => {
    const [searchParams] = useSearchParams();
    const project = searchParams.get('project') || '';

    useEffect(() => {
        if (project) {
            window.location.href = `/${project}/login`;
        } else {
            window.location.href = '/login';
        }
    }, []);
};

export default SystemCompatibilityPage;